<footer class="page-footer page-footer-height">
  <div class="footer-content">
    <div class="container-fluid footer-padding">
      <div class="row">
        <div class="col-12 col-sm-6">
          <p class="mb-0 text-muted text-font-size">iSplendid 2021 - 2022</p>
        </div>
      </div>
    </div>
  </div>
</footer>